module.exports = __webpack_public_path__ + "img/Skirt-Back-B8-Db.c15c20cf.png";